import type { ChannelVerifyStatus } from '@/api/channel/type'

export const VERIFIED_STATUS: ChannelVerifyStatus[] = ['ACTIVATED', 'VERIFIED']

export const isVerified = (status: ChannelVerifyStatus) => VERIFIED_STATUS.includes(status)
